import { useAuthStore } from "@/stores/auth";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routers";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.meta.requiresAuth;

  if (requiresAuth || to.name === "Login") {
    if (!authStore.isValidated) {
      try {
        await authStore.fetchUser();
      } catch {
        authStore.clearSession();
      }
    }
  }

  if (to.name === "Login" && authStore.isAuthenticated) {
    return next({ name: "Home" });
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    const apiUrl = `${import.meta.env.VITE_HTTP_PROTOCOL}://${import.meta.env.VITE_API_URL}`;
    window.location.href = `${apiUrl}/auth/check-sso`;
    return;
  }

  if (to.name === "Login" && !authStore.isAuthenticated) {
    const ssoFailed = to.query.sso_checked === "true";
    if (!ssoFailed) {
      const apiUrl = `${import.meta.env.VITE_HTTP_PROTOCOL}://${import.meta.env.VITE_API_URL}`;
      window.location.href = `${apiUrl}/auth/check-sso`;
      return;
    }
    return next();
  }

  return next();
});

export default router;
